import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmForm";
import {cancelRemovePackageFromShippingOrder} from "../../actions/ShippingApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class RemovePackageFromOrderFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      orderId: this.props.orderId,
      packageId: this.props.packageId
    }
    return this.props.removePackageFromShippingOrder(updatedValues)
      .then((response) => {
        if (response.data.removePackageFromShippingOrder.errors.length <= 0) {
          this.props.cancelRemovePackageFromShippingOrder();
        } else {
          let errors = createValidationErrors(response.data.removePackageFromShippingOrder.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRemovePackageFromShippingOrder();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        message={"Are you sure you want to remove this package?"}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const REMOVE_PACKAGE = gql`
  mutation removePackageFromShippingOrder($data: RemovePackageFromShippingOrderInput!) {
    removePackageFromShippingOrder(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(REMOVE_PACKAGE, {
    props: ({ mutate }) => ({
      removePackageFromShippingOrder: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelRemovePackageFromShippingOrder})(withMutation(RemovePackageFromOrderFormContainer));